import React, { useState, useMemo, useEffect } from "react";

const MultipleChoice = ({
  questionId,
  setAnswersList,
  answersList,
  questionOptions,
  maxAnsNum,
  submit,
}) => {
  const [choiceList, setChoiceList] = useState([]);
  const [isAllowDesc, setIsAllowDesc] = useState(false);
  const [descId, setDescId] = useState(null);
  const [description, setDescription] = useState("");
  const [isFirstTime, setIsFirstTime] = useState(null);
  const [isSetDesc, setIsSetDesc] = useState(false);

  const answerIdx = useMemo(
    () => answersList.findIndex((item) => item.questionId === questionId),
    [answersList, questionId]
  );

  useEffect(() => {
    // Set choice list here in order to show everything
    // including the description
    if (answersList[answerIdx] && choiceList.length === 0) {
      setChoiceList(answersList[answerIdx].answers);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (answerIdx === -1) {
      setIsFirstTime(true);
    } else {
      setIsFirstTime(false);
    }
  }, [answerIdx]);

  useEffect(() => {
    // If user has come back, set the various things description needs
    if (choiceList && isFirstTime === false && isSetDesc === false) {
      setIsSetDesc(true);
      for (let choice of choiceList) {
        if (choice.description !== null) {
          setDescId(choice.optionId);
          setDescription(choice.description);
          setIsAllowDesc(true);
        }
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [choiceList, isFirstTime]);

  useEffect(() => {
    // Check if answer already exists
    if (answerIdx === -1) {
      let newScreenAnswersList = answersList;
      newScreenAnswersList.push({
        answers: choiceList,
        questionId: questionId,
      });

      setAnswersList([...newScreenAnswersList]);
    } else {
      if (choiceList.length !== 0) {
        let newScreenAnswersList = answersList;
        newScreenAnswersList[answerIdx] = {
          answers: choiceList,
          questionId: questionId,
        };

        setAnswersList([...newScreenAnswersList]);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [choiceList]);

  useEffect(() => {
    if (isAllowDesc === false) {
      setDescription("");
    }
  }, [isAllowDesc]);

  useEffect(() => {
    if (description.length > 0) {
      // Find position where description must be placed
      const descPos = choiceList.findIndex((o) => o.optionId === descId);

      // Replace description
      let choiceListCopy = choiceList;
      choiceListCopy[descPos].description = description;

      setChoiceList([...choiceListCopy]);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [description]);

  function onChoiceSelect(optionId, needDescription) {
    const isMultipleChoice = maxAnsNum > 1 ? true : false;
    let isIncluded;

    if (choiceList.length !== 0) {
      isIncluded = choiceList.find((o) => o.optionId === optionId)
        ? true
        : false;
    }

    if (isMultipleChoice && isIncluded) {
      let choiceListCopy = choiceList;
      choiceListCopy.splice(
        choiceList.findIndex((o) => o.optionId === optionId),
        1
      );
      setChoiceList([...choiceListCopy]);
    } else if (isMultipleChoice && !isIncluded) {
      setChoiceList([
        ...choiceList,
        {
          optionId: optionId,
          description: needDescription && isAllowDesc ? description : "",
        },
      ]);
    } else if (!isMultipleChoice && !isIncluded) {
      setChoiceList([
        {
          optionId: optionId,
          description: needDescription && isAllowDesc ? description : "",
        },
      ]);
    }
  }

  return (
    <div className="square-radio-div">
      <ul>
        {questionOptions.map(({ id, name, needDescription }) => (
          <li key={id}>
            <label htmlFor={`choice-${id}`}>
              <input
                type={maxAnsNum > 1 ? "checkbox" : "radio"}
                name={`survey-choice-${id}`}
                value={name}
                onChange={() => {
                  onChoiceSelect(id, needDescription);
                  if (needDescription) {
                    setDescId(id);
                    setIsAllowDesc(!isAllowDesc);
                  }
                  if (maxAnsNum === 1 && !needDescription) {
                    setIsAllowDesc(false);
                    setDescription("");
                  }

                  // setTimeout(() => {
                  //   submit();
                  // }, 500);
                }}
                checked={
                  choiceList.find((o) => o.optionId === id) ? true : false
                }
              />
              {name}
              {needDescription && isAllowDesc && (
                <input
                  type="string"
                  placeholder="의견을 작성해 주세요"
                  className="ans-txt"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              )}
            </label>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default MultipleChoice;
